import React, { useState } from "react";
import "./Bookmark.css";
import { IconBookmark, IconBookmarkUnfilled } from "../icons";

interface Props {
  id?: string;
  onClick: (isChecked: boolean) => void;
  checked?: boolean;
  className?: string;
  ariaLabel?: string;
}

export const Bookmark = ({ id, onClick, checked, className, ariaLabel }: Props) => {
  const defaultState = checked ? true : false;
  const [isChecked, toggleChecked] = useState(defaultState);

  const handleClick = (e: React.FormEvent<HTMLButtonElement>) => {
    onClick(!isChecked);
    toggleChecked(!isChecked);
    e.stopPropagation();
  };

  return (
    <button
      id={id}
      onClick={handleClick}
      aria-label={ariaLabel ? ariaLabel : "Bookmark"}
      aria-pressed={checked}
      className={"Bookmark " + (checked ? "checked " : "") + (className || "")}
    >
      {checked ? <IconBookmark /> : <IconBookmarkUnfilled />}
    </button>
  );
};
